<mat-list-item class="projet-container active projetLine">
    <div class="projet-content">
        <mat-checkbox></mat-checkbox>
        <div style="margin-left: 20px">
            {{generateHtmlFromTemplate()}}
        </div>

    </div>
</mat-list-item>